import {assetsListActions} from '../assets'

const clearMakeModelAction = () => {
  return (dispatch) => {
    dispatch(assetsListActions.clearModelByMake())
  }
}

export default clearMakeModelAction
